module.exports = __webpack_public_path__ + "static/media/octopus.9bdf0a35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/protein/octopus.jpg
// module id = 106
// module chunks = 0